import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { WithdrawalHistoryPageRoutingModule } from './withdrawal-history-routing.module';

import { WithdrawalHistoryPage } from './withdrawal-history.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    WithdrawalHistoryPageRoutingModule
  ],
  declarations: [WithdrawalHistoryPage]
})
export class WithdrawalHistoryPageModule {}
